import { atom } from "jotai"

/** Whether the header search field is expanded. */
const searchOpenAtom = atom(false)

/**
 * Catalog search term.
 *
 * Shared state rather than page-local: the field lives in the header chrome
 * while the results live in the menu pages, and the previous split (open flag
 * in an atom, term in each page's useState) is what forced the field to be
 * portaled out of the header with hand-tuned margins.
 */
const searchTermAtom = atom("")

/** Collapses the field and clears the term in a single write. */
const closeSearchAtom = atom(null, (_get, set) => {
  set(searchOpenAtom, false)
  set(searchTermAtom, "")
})

export { closeSearchAtom, searchOpenAtom, searchTermAtom }
